import React from 'react';
import styles from './Dashboard.module.css';
import { formatDateTime } from '../../utils/dateFormatter';

const RecentSubmissionsTable = ({ submissions }) => {

    return (
        <div className={styles.contentSection}>
            <div className={styles.card}>
                <div className={styles.tableHeader}>
                    <h2 className={styles.cardTitle}>Recent Submissions</h2>
                    <p className={styles.tableSubtitle}>Latest study submissions since 15 days</p>
                </div>
                <div className={styles.tableContainer}>
                    {submissions.length > 0 ? (
                        <table className={styles.submissionsTable}>
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Email Address</th>
                                    <th>Contact Number</th>
                                    <th>Study</th>
                                    <th>Site</th>
                                    <th>Submission Date & Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {submissions.map((submission, index) => (
                                    <tr key={index}>
                                        <td>{submission.full_name || '-'}</td>
                                        <td className={styles.emailCell}>{submission.email || '-'}</td>
                                        <td>{submission.contact_number || '-'}</td>
                                        <td>{submission.study_title || '-'}</td>
                                        <td>{submission.site_name || '-'}</td>
                                        <td className={styles.dateTimeCell}>
                                            {formatDateTime(submission.submitted_at)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className={styles.noData}>
                            <p>No submissions yet</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecentSubmissionsTable;